/**
 * Ermöglicht die Anzeige des Suchformulars und der Suchergebnisse.
 * @class directive_v3sSearch
 * @memberOf v3sWbtPlayerApp:tools:search
 */
angular.module('v3sWbtPlayerApp').directive('v3sSearch', ["v3sLexikonService", "v3sNavigationService", "v3sSearchService", "v3sWbtDataService", function (v3sLexikonService, v3sNavigationService, v3sSearchService, v3sWbtDataService) {
    /*
     * Fügt den neuen Suchbegriff den alten Suchbegriffen hinzu. Der letzte Suchbegriff wird dabei ersetzt.
     */
    function mergeTerms(oldTerm, newTerm) {
        if (!oldTerm || !oldTerm.trim()) {
            return newTerm;
        }

        var terms = oldTerm.split(" ");
        terms.pop();
        terms.push(newTerm);

        return terms.join(" ");
    }

    /*
     * Gibt die Liste aller Seiten als Suchergebnis zurück.
     */
    function findAllPages() {
        var items = v3sWbtDataService.getWbt().children;
        var pages = [];

        addPages(pages, items);

        return pages;
    }

    /*
     * Fügt alle Seiten des gegebenen Teilbaums der Ergebnisliste hinzu.
     */
    function addPages(pageList, items) {
        var index, item, searchResult;

        for (index in items) {
            item = items[index];

            if ((!item.sco || item.type === "structureSco") && item.isVisible()) {
                searchResult = {
                    title: item.title,
                    id: item.id,
                    weight: 1, type: "page",
                    href: v3sNavigationService.getHref(v3sNavigationService.getPageState(item))
                };
                pageList.push(searchResult);
            }

            if (item.children && item.children.length > 0 && item.children[0].id != item.id) {
                addPages(pageList, item.children);
            }
        }
    }

    return {
        restrict: 'E',
        scope: {},
        transclude: false,
        templateUrl: "app/js/tools/search/searchContent.tpl.html",
        link: function (scope, element, attrs) {
            scope.searchFilter = {
                lastSearchTerm: "",
                searchTerm: "",
                mode: "all",
                hasLexikon: false
            }
            scope.searchResults = [];

            v3sSearchService.getSearchIndex().then(function (searchIndex) {
                scope.suggestions = searchIndex;
            });

            v3sLexikonService.getLexikon().then(function (lexikon) {
                scope.lexikon = lexikon;
                scope.searchFilter.hasLexikon = lexikon && Object.keys(lexikon).length;
            });

            scope.updateResults = function () {
                var filter = scope.searchFilter;
                scope.searchResults = [];

                if (filter.searchTerm) {
                    if (filter.searchTerm.term) {
                        filter.searchTerm = mergeTerms(filter.lastSearchTerm, filter.searchTerm.term);

                    } else {
                        filter.lastSearchTerm = filter.searchTerm;
                    }

                    v3sSearchService.findPages(filter.searchTerm, filter.mode).then(function (pages) {
                        var i, page, item, searchResult, wbt, title;

                        for (i = 0; i < pages.length; i++) {
                            page = pages[i];
                            searchResult = null;
                            if (page.type == "page") {
                                wbt = v3sWbtDataService.getWbt();
                                item = wbt.getItem(page.path);

                                if (item && item.isVisible()) {
                                    searchResult = { title: item.title, id: item.id, weight: page.weight, type: page.type };
                                    searchResult.href = v3sNavigationService.getHref(v3sNavigationService.getPageState(item));
                                }

                            } else {
                                title = pages[i].path;
                                if (scope.lexikon && scope.lexikon[title]) {
                                    title = scope.lexikon[title].title;
                                }
                                searchResult = { title: title, id: pages[i].path, weight: page.weight, type: page.type };
                            }

                            if (searchResult) {
                                scope.searchResults.push(searchResult);
                            }
                        }
                    });

                } else if (filter.mode === "lexikon" && scope.lexikon) {
                    for (var path in scope.lexikon) {
                        scope.searchResults.push({
                            title: scope.lexikon[path].title,
                            id: path,
                            weight: 1,
                            type: "lexikon"
                        });
                    }
                } else if (filter.mode === "page") {
                    scope.searchResults = findAllPages();
                }
            }

            scope.submitSearch = function () {
                var inputs = element.find("input");
                if (inputs.length > 0) {
                    inputs[0].blur();
                }
            }

            /*
             * Matcht, wenn der letzte Begriff aus den erwarteten Begriffen im tatsächlichen Begriff vorkommt.
             */
            scope.matchLast = function (actual, expected) {
                if (!actual || !expected) {
                    return false;
                }

                var terms = (expected.term || expected).split(" ");
                var term = terms[terms.length - 1].toLocaleLowerCase();

                return actual.toLocaleLowerCase().indexOf(term) > -1;
            }

            scope.openSearchResult = function (searchResult, event) {
                if (event.which > 1) {
                    return;
                }

                if (searchResult.type == "lexikon") {
                    v3sSearchService.showLexikonEntry(searchResult.id);
                }
            }
        }
    }
}]);
